import { useState, useEffect, useRef } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Spinner, Alert } from "react-bootstrap";

function SpeicherCheck({
  speichercheck,
  setSpeicherCheck,
  sendData,
  verwerfen,
  loading,
  setKachel,
  setProjektstufe,
  setSelectedKachel
}) {
  const [checkdone, setCheckdone]=useState(false)
  function handleClose() {
    setSpeicherCheck({active: false});
  }

  useEffect(() => {
    if (loading === "success" && speichercheck.active) {
      setCheckdone(true)
      setTimeout(() => {
        setSpeicherCheck({active:false});
        
      }, 1000);
      setTimeout(() => {
        setCheckdone(false)
        
      // setSelectedKachel();
      }, 1300);
    }
  }, [loading]);

  return (
    <>
      <Modal
        show={speichercheck.active}
        onClick={(e) => {
          e.stopPropagation();
        }}
        onHide={handleClose}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {loading === "success" ? <p>👍</p> : <p>Daten speichern?</p>}
          </Modal.Title>
        </Modal.Header>
        {!(loading === "success" || checkdone) && (
          <Modal.Body>Änderungen wurden noch nicht gespeichert</Modal.Body>
        )}
        {!checkdone&&<Modal.Footer>
          {loading === "loading" || loading === "success" ? (
            <Spinner
              as="span"
              animation="grow"
              size="sm"
              role="status"
              aria-hidden="true"
            />
          ) : (
            <>
              <Button
                variant="danger"
                onClick={() => {
                  verwerfen();
                  speichercheck.type==="tab"&&setProjektstufe(speichercheck.name)
                  speichercheck.type==="accordion"&&setSelectedKachel(speichercheck.name)
                  setSpeicherCheck({active: false});
                }}
              >
                Änderungen verwerfen
              </Button>
              <Button
                variant="primary"
                onClick={async() => {
                  await sendData({});
                  speichercheck.type==="tab"&&setProjektstufe(speichercheck.name)
                  speichercheck.type==="accordion"&&setSelectedKachel(speichercheck.name)
                }}
              >
                Speichern
              </Button>
              <Button variant="secondary" onClick={handleClose}>
                Abbrechen
              </Button>
            </>
          )}
        </Modal.Footer>}
      </Modal>
    </>
  );
}

export default SpeicherCheck;
